// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Rating-errorMessage-sC7Yz {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}

.Rating-landingContainer-fgcfg {
	max-width: var(--max-container-width);
	width: 100%;
	display: block;
	margin: 40px auto 0;
}

.Rating-noPadding-UM17f {
	padding: 0;
}

.Rating-landingContentTitle-ODUPD {
	font-size: 26px;
	margin: 0 0px 20px;
	font-weight: 600;
}

.Rating-landingStep-zF0Ic {
	font-size: 20px;
	margin: 0 0px 12px;
	display: inline-block;
}

.Rating-horizontalLineThrough-_Pa49 {
	margin: 15px 0px 30px;
	color: var(--primary-border);
}

.Rating-btn-nWOpW {
	display: inline-block;
	margin-bottom: 0;
	font-size: 16px;
	line-height: 1.42857143;
	text-align: center;
	-ms-touch-action: manipulation;
	    touch-action: manipulation;
	cursor: pointer;
	border: 1px solid transparent;
	border-radius: 4px;
}

.Rating-btnJumbo-L3LYT {
	padding: 20px 36px;
	line-height: 1;
	font-size: 18px;
	text-align: center;
}

.Rating-formGroup-IQzHm {
	margin-bottom: 6px;
}

.Rating-textareaInput-GPaNN {
	height: 140px !important;
	padding: 18px !important;
	border-color: var(--primary-border);
	font-size: 16px !important;
	border-radius: 6px;
}

.Rating-imgContainer-p8Hf0 {
	position: relative;
	width: 100%;
}

.Rating-parent-QsvWR {
	background: var(--secondary-gray-bg) none repeat scroll 0 0;
	padding-top: 56.6667%;
	position: relative;
	border-radius: 15px;
}

.Rating-children-ZuhSq {
	bottom: 0;
	height: 100%;
	left: 0;
	position: absolute;
	right: 0;
	top: 0;
	width: 100%;
}

.Rating-content-ZkULI {
	height: 100%;
	width: 100%;
	position: relative;
}

.Rating-imageContent-nYKUf {
	height: 100%;
	width: 100%;
	background-position: 50% 50%;
	background-repeat: no-repeat;
	background-size: cover;
	position: absolute;
	border-radius: 15px;
}

.Rating-starSize-h4h1T {
	font-size: 28px;
}

.Rating-textBold-TEFjI {
	font-weight: bold;
}

.Rating-reviewEndText-lT2Qk {
	font-size: 16px;
	color: var(--primary-foreground);
}

.Rating-textMuted-I7nA4,
.Rating-textMuted-I7nA4:hover,
.Rating-textMuted-I7nA4:focus,
.Rating-textMuted-I7nA4:hover:focus {
	text-decoration: none;
	font-size: 12px;
}

.Rating-viewText-xiU6d {
	color: var(--secondary-foreground);
	font-size: 14px;
	margin-top: 12px;
}

.Rating-lineCss-pMsje {
	margin: 30px 0;
	border-top: 1px solid var(--primary-border);
}

.Rating-cancelBtn-j0WL2 {
	color: var(--primary-link-foreground) !important;
	margin-right: 30px;
	font-size: 16px;
	text-decoration: none !important;
	cursor: pointer;
}

.Rating-alignRight-_3oes {
	text-align: right;
	margin-top: 19px;
}

.Rating-titleText-UGEXm {
	font-size: 18px;
	color: var(--primary-foreground);
	font-weight: 500;
	margin: 0px 0 3px;
}

.Rating-starFont-ssBul {
	font-size: 12px;
	margin-top: 14px;
	gap: 1px
}

.Rating-smallText-wFSCn {
	color: var(--secondary-foreground);
	margin-bottom: 5px;
}

.Rating-starFont-ssBul {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
}

.Rating-dotsCss-OmOck {
	margin: 0 8px;
}

.Rating-reviewFlex-b2b1j {
	display: grid;
	grid-template-columns: 53% 40%;
	grid-column-gap: 70px;
}

.Rating-ratingImageContainer-SLyam {
	max-width: 415px;
}

.Rating-reviewTop-KUcdf {
	margin-top: 15px;
}

.Rating-space5-Pt52O {
	margin-bottom: 30px !important;
}

.Rating-writeReviewStar-AZiha svg {
	font-size: 32px;
	cursor: pointer;
}

@media screen and (max-width: 1199px) {
	.Rating-landingContainer-fgcfg {
		margin: 110px auto 0;
	}

	.Rating-reviewFlex-b2b1j {
		grid-template-columns: 50% 40%;
		grid-column-gap: 70px;
	}
}

@media screen and (max-width: 767px) {
	.Rating-showLg-SPLTX {
		display: none;
	}

	.Rating-reviewFlex-b2b1j {
		grid-template-columns: 100%;
		grid-row-gap: 35px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/utils.css","webpack://./src/components/Reviews/Rating/Rating.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;ACJA;CACC,qCAAqC;CACrC,WAAW;CACX,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,eAAe;CACf,uBAAuB;CACvB,kBAAkB;CAClB,8BAA0B;KAA1B,0BAA0B;CAC1B,eAAe;CACf,6BAA6B;CAC7B,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,wBAAwB;CACxB,wBAAwB;CACxB,mCAAmC;CACnC,0BAA0B;CAC1B,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,2DAA2D;CAC3D,qBAAqB;CACrB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,SAAS;CACT,YAAY;CACZ,OAAO;CACP,kBAAkB;CAClB,QAAQ;CACR,MAAM;CACN,WAAW;AACZ;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,4BAA4B;CAC5B,4BAA4B;CAC5B,sBAAsB;CACtB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,gCAAgC;AACjC;;AAEA;;;;CAIC,qBAAqB;CACrB,eAAe;AAChB;;AAEA;CACC,kCAAkC;CAClC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,2CAA2C;AAC5C;;AAEA;CACC,gDAAgD;CAChD,kBAAkB;CAClB,eAAe;CACf,gCAAgC;CAChC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gCAAgC;CAChC,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB;AACD;;AAEA;CACC,kCAAkC;CAClC,kBAAkB;AACnB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,eAAe;CACf,eAAe;AAChB;;AAEA;CACC;EACC,oBAAoB;CACrB;;CAEA;EACC,8BAA8B;EAC9B,qBAAqB;CACtB;AACD;;AAEA;CACC;EACC,aAAa;CACd;;CAEA;EACC,2BAA2B;EAC3B,kBAAkB;CACnB;AACD","sourcesContent":[".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}","@import '../../utils.css';\n\n.landingContainer {\n\tmax-width: var(--max-container-width);\n\twidth: 100%;\n\tdisplay: block;\n\tmargin: 40px auto 0;\n}\n\n.noPadding {\n\tpadding: 0;\n}\n\n.landingContentTitle {\n\tfont-size: 26px;\n\tmargin: 0 0px 20px;\n\tfont-weight: 600;\n}\n\n.landingStep {\n\tfont-size: 20px;\n\tmargin: 0 0px 12px;\n\tdisplay: inline-block;\n}\n\n.horizontalLineThrough {\n\tmargin: 15px 0px 30px;\n\tcolor: var(--primary-border);\n}\n\n.btn {\n\tdisplay: inline-block;\n\tmargin-bottom: 0;\n\tfont-size: 16px;\n\tline-height: 1.42857143;\n\ttext-align: center;\n\ttouch-action: manipulation;\n\tcursor: pointer;\n\tborder: 1px solid transparent;\n\tborder-radius: 4px;\n}\n\n.btnJumbo {\n\tpadding: 20px 36px;\n\tline-height: 1;\n\tfont-size: 18px;\n\ttext-align: center;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.textareaInput {\n\theight: 140px !important;\n\tpadding: 18px !important;\n\tborder-color: var(--primary-border);\n\tfont-size: 16px !important;\n\tborder-radius: 6px;\n}\n\n.imgContainer {\n\tposition: relative;\n\twidth: 100%;\n}\n\n.parent {\n\tbackground: var(--secondary-gray-bg) none repeat scroll 0 0;\n\tpadding-top: 56.6667%;\n\tposition: relative;\n\tborder-radius: 15px;\n}\n\n.children {\n\tbottom: 0;\n\theight: 100%;\n\tleft: 0;\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\twidth: 100%;\n}\n\n.content {\n\theight: 100%;\n\twidth: 100%;\n\tposition: relative;\n}\n\n.imageContent {\n\theight: 100%;\n\twidth: 100%;\n\tbackground-position: 50% 50%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\tposition: absolute;\n\tborder-radius: 15px;\n}\n\n.starSize {\n\tfont-size: 28px;\n}\n\n.textBold {\n\tfont-weight: bold;\n}\n\n.reviewEndText {\n\tfont-size: 16px;\n\tcolor: var(--primary-foreground);\n}\n\n.textMuted,\n.textMuted:hover,\n.textMuted:focus,\n.textMuted:hover:focus {\n\ttext-decoration: none;\n\tfont-size: 12px;\n}\n\n.viewText {\n\tcolor: var(--secondary-foreground);\n\tfont-size: 14px;\n\tmargin-top: 12px;\n}\n\n.lineCss {\n\tmargin: 30px 0;\n\tborder-top: 1px solid var(--primary-border);\n}\n\n.cancelBtn {\n\tcolor: var(--primary-link-foreground) !important;\n\tmargin-right: 30px;\n\tfont-size: 16px;\n\ttext-decoration: none !important;\n\tcursor: pointer;\n}\n\n.alignRight {\n\ttext-align: right;\n\tmargin-top: 19px;\n}\n\n.titleText {\n\tfont-size: 18px;\n\tcolor: var(--primary-foreground);\n\tfont-weight: 500;\n\tmargin: 0px 0 3px;\n}\n\n.starFont {\n\tfont-size: 12px;\n\tmargin-top: 14px;\n\tgap: 1px\n}\n\n.smallText {\n\tcolor: var(--secondary-foreground);\n\tmargin-bottom: 5px;\n}\n\n.starFont {\n\tdisplay: flex;\n}\n\n.dotsCss {\n\tmargin: 0 8px;\n}\n\n.reviewFlex {\n\tdisplay: grid;\n\tgrid-template-columns: 53% 40%;\n\tgrid-column-gap: 70px;\n}\n\n.ratingImageContainer {\n\tmax-width: 415px;\n}\n\n.reviewTop {\n\tmargin-top: 15px;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.writeReviewStar svg {\n\tfont-size: 32px;\n\tcursor: pointer;\n}\n\n@media screen and (max-width: 1199px) {\n\t.landingContainer {\n\t\tmargin: 110px auto 0;\n\t}\n\n\t.reviewFlex {\n\t\tgrid-template-columns: 50% 40%;\n\t\tgrid-column-gap: 70px;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.showLg {\n\t\tdisplay: none;\n\t}\n\n\t.reviewFlex {\n\t\tgrid-template-columns: 100%;\n\t\tgrid-row-gap: 35px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `Rating-errorMessage-sC7Yz`,
	"landingContainer": `Rating-landingContainer-fgcfg`,
	"noPadding": `Rating-noPadding-UM17f`,
	"landingContentTitle": `Rating-landingContentTitle-ODUPD`,
	"landingStep": `Rating-landingStep-zF0Ic`,
	"horizontalLineThrough": `Rating-horizontalLineThrough-_Pa49`,
	"btn": `Rating-btn-nWOpW`,
	"btnJumbo": `Rating-btnJumbo-L3LYT`,
	"formGroup": `Rating-formGroup-IQzHm`,
	"textareaInput": `Rating-textareaInput-GPaNN`,
	"imgContainer": `Rating-imgContainer-p8Hf0`,
	"parent": `Rating-parent-QsvWR`,
	"children": `Rating-children-ZuhSq`,
	"content": `Rating-content-ZkULI`,
	"imageContent": `Rating-imageContent-nYKUf`,
	"starSize": `Rating-starSize-h4h1T`,
	"textBold": `Rating-textBold-TEFjI`,
	"reviewEndText": `Rating-reviewEndText-lT2Qk`,
	"textMuted": `Rating-textMuted-I7nA4`,
	"viewText": `Rating-viewText-xiU6d`,
	"lineCss": `Rating-lineCss-pMsje`,
	"cancelBtn": `Rating-cancelBtn-j0WL2`,
	"alignRight": `Rating-alignRight-_3oes`,
	"titleText": `Rating-titleText-UGEXm`,
	"starFont": `Rating-starFont-ssBul`,
	"smallText": `Rating-smallText-wFSCn`,
	"dotsCss": `Rating-dotsCss-OmOck`,
	"reviewFlex": `Rating-reviewFlex-b2b1j`,
	"ratingImageContainer": `Rating-ratingImageContainer-SLyam`,
	"reviewTop": `Rating-reviewTop-KUcdf`,
	"space5": `Rating-space5-Pt52O`,
	"writeReviewStar": `Rating-writeReviewStar-AZiha`,
	"showLg": `Rating-showLg-SPLTX`
};
module.exports = ___CSS_LOADER_EXPORT___;
